<template>
    <div>
        <table class="table  is-fullwidth is-size-7" >
        <thead>
          <tr>
          <th>ID</th>
          <th>&nbsp;</th>
            <th>Type</th>
            
            <th>Qty</th>
            <th>Extras</th>
            <th style="display:none">Files</th>
            
           <th>Artwork</th>
              <th>Digi Print</th>
              <th style="display:none">Trans</th>
              <th>Gerber</th>
              <th>Sundries</th>
              <th>Makeup</th>
              <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="row in samples">
          <tr  :class="{'has-background-success-light' : row.processed == 1, 'has-background-link-light' : row.processed == 0}" :key="'header' + row.id">
            <th ><router-link :to="'/samples/view/' + row.id" >{{ row.id}}</router-link></th>
                <th colspan="9">
                  <span v-if="row.team_id > 0">{{ row.team_name}}</span>
                  <span v-if="row.team_id == -1">{{ row.club_name}}</span>
                  <span v-if="row.user_firstname != '' || row.user_surname != ''"> | {{ row.user_firstname}} {{ row.user_surname }}</span>
                  | {{ row.date | formatUKDate}}
                </th>
                <th >
                  
                  <span class="button tag is-link" @click="openThisProcessModal(row.id)" v-if="row.items.length > 0 && row.processed ==0">Process</span>
                  <span class="button tag is-grey " title="No items created"  v-if="row.items.length == 0" @click="alertNoItems();">Process</span>
                  <span class="button tag is-success" style="display:none" @click="completeSample(row)" v-if="row.items.length > 0 && row.processed == 1 && row.completed == 0">Complete</span>
                </th>
              </tr>
            
            <tr v-for="(item, index) in row.items" :key="item.id">
                <td>{{ index+1 }}</td>
                <td>{{ item.garmentname }}
                  <span v-if="item.garment_id==0"> {{ item.new_garment_name }}</span>
                </td>
                <td>{{ item.sample_item_type_name }}</td>
                <td>{{ item.quantity}}</td>
                <td class="">
                  <div class="tags">
                    <span class="tag " v-if="item.embroidery==1" :class="{'is-success' : item.embroidery_completed==1}">Embroidery</span>
                    <span class="tag " v-if="item.trims==1" :class="{'is-success' : item.trims_completed==1}">Trims</span>
                    <span class="tag " v-if="item.dtf==1" :class="{'is-success' : item.dtf_completed==1}">DTF</span>
                    <span class="tag " v-if="item.silicon==1" :class="{'is-success' : item.silicon_completed==1}">Silcon</span>
                  </div>
                </td>
                <td style="display:none"><i class="fa fa-folder" aria-hidden="true"></i></td>
                
                 <td><span class="button tag is-success" v-if="item.artwork_completed==1">Done</span></td>
                  <td>
                    <span class="button tag is-light" v-if="item.sample_item_type_id ==3">N/A</span>
                    <span class="button tag is-success"  v-else-if="item.digital_print_completed==1">Done</span>
                </td>
                  <td style="display:none">
                    <span class="button tag is-light" v-if="item.sample_item_type_id ==3">N/A</span>
                    <span class="button tag is-success" v-else-if="item.trans_completed==1">Done</span>
                </td>
                  <td>
                    <span class="button tag is-light" v-if="item.sample_item_type_id ==3">N/A</span>
                     <span class="button tag is-success" v-else-if="item.gerber_cutting_completed==1">Done</span>
                  </td>
                  <td></td>
                  <td>
                    <span class="button tag is-light" v-if="item.sample_item_type_id ==4">N/A</span>
                    <span class="button tag is-success" v-else-if="item.makeup_completed==1">Done</span>
                    <span v-else>{{  item.makeup_location_name }}</span>
                </td>
                <td>&nbsp;</td>
            </tr>
          
          </template>
            
        </tbody>
      </table>
    </div>
</template>

<script>
     import SampleService from '@/services/SampleService.js';

    export default {
      
      name: 'ListSamplesTable',
        mixins: [],
        data: function () {
            return {
                   
                   
            }
        },
        methods:  {
                openThisProcessModal(id) {
                  //alert(id)
                  console.log("Emitting open-modal with:", id);
                    this.$emit("open-modal", id);
                },
                alertNoItems(){
                  alert(' No items have been created for this sample so it cannot be moved on.')
                },
                completeSample(sample){
                    var formdata = { 
                     completed: 1,
                    
                  }; 

                  SampleService.completeSample(this.accessToken, sample.id, formdata)
                  .then((response) => {
                      console.log(response)
                      sample.completed = 1
                      }).catch((error) => {
                          if(error.response.status === 422)
                          {
                              console.log("Error:" + JSON.stringify(error.response.data));
                          }
                          alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                          this.working = false
                  });
                }
        },
        props: ['samples'],
        created() {
          this.getAccessToken()
            .then(() => { 
               
            });
          
        },
    }
    </script>